import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Auth0Provider } from "@auth0/auth0-react";
import "./index.css";
import "react-tooltip/dist/react-tooltip.css";
import { baseURL } from "./utils";

const onRedirectCallback = (appState) => {
  const returnTo = appState?.returnTo || "/";

  const safeReturnTo = returnTo.startsWith("/") && !returnTo.startsWith("//") && !returnTo.startsWith("/\\") ? returnTo : "/";

  // Auth0 has already completed its callback. Update the address before
  // React Router mounts, without loading the homepage or reloading the app.
  window.history.replaceState(window.history.state, "", safeReturnTo);
};

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  // <React.StrictMode>
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENTID}
    cacheLocation="localstorage"
    useRefreshTokens={true}
    onRedirectCallback={onRedirectCallback}
    authorizationParams={{
      redirect_uri: baseURL(),
      audience: process.env.REACT_APP_AUTH0_AUDIENCE,
      scope: "openid profile email offline_access",
    }}
  >
    <App />
  </Auth0Provider>,
  // </React.StrictMode>
);
